import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";
import dsteem from "../unit/DsteemUtil";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import PostCard from "../components/PostComponents/PostCard.vue";
import { $t } from "../plugins/i18n";
export default {
  components: {
    PostCard: PostCard
  },
  data: function data() {
    return {
      loginData: null,
      blogs: [],
      name: ""
    };
  },
  methods: {
    loadAccount: function loadAccount() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loginData = extractLoginData();

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onRefresh: function onRefresh(done) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dsteem.getAccountBlogsByBridge(_this2.name ? _this2.name : _this2.loginData ? _this2.loginData[0] : null, "feed", _this2.name ? _this2.name : _this2.loginData ? _this2.loginData[0] : null, 20);

              case 2:
                _this2.blogs = _context2.sent;
                done();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onLoad: function onLoad(done) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var permlink, author, nextblogs;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                permlink = _this3.blogs[_this3.blogs.length - 1].permlink;
                author = _this3.blogs[_this3.blogs.length - 1].author;
                _context3.next = 4;
                return dsteem.getAccountBlogsByBridge(_this3.name ? _this3.name : _this3.loginData ? _this3.loginData[0] : null, "feed", _this3.name ? _this3.name : _this3.loginData ? _this3.loginData[0] : null, 20, permlink, author);

              case 4:
                nextblogs = _context3.sent;
                //console.log(nextblogs);
                nextblogs.shift();

                _this3.blogs.push.apply(_this3.blogs, nextblogs);

                done();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _this4$$route$params, _this4$$route$params$;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.loadAccount();

            case 2:
              _this4.name = (_this4$$route$params = _this4.$route.params) === null || _this4$$route$params === void 0 ? void 0 : (_this4$$route$params$ = _this4$$route$params.username) === null || _this4$$route$params$ === void 0 ? void 0 : _this4$$route$params$.replace("@", ""); //console.log(this.name);

              _context4.next = 5;
              return dsteem.getAccountBlogsByBridge(_this4.name ? _this4.name : _this4.loginData ? _this4.loginData[0] : null, "feed", _this4.name ? _this4.name : _this4.loginData ? _this4.loginData[0] : null, 20);

            case 5:
              _this4.blogs = _context4.sent;

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  }
};